export function appendTestId(prefix: string | undefined, id: string | number) {
  return prefix ? `${prefix}-${id}` : undefined;
}
